
    import { Component, Vue, Watch } from 'vue-property-decorator'
    let dg_icon_1 = require('./../../../assets/imgs/dg_icon_1.png'),
        dg_icon_2 = require('./../../../assets/imgs/dg_icon_2.png'),
        dg_icon_3 = require('./../../../assets/imgs/dg_icon_3.png');
    @Component({
        name: 'DashGoodteaching'
    })
    export default class DashGoodteaching extends Vue {
        private dgContentLists: Array<any> = [
            { title: '教', subTitle1: '互动课件', text1: '小学低年级采用交互式课件，样式丰富多彩，让孩子爱上学习', subTitle2: '小班授课', text2: '每个班级人数在20人左右，确保每个孩 子都有良好的学习环境。', icon: dg_icon_1 },
            { title: '学', subTitle1: '家长旁听', text1: '在符合要求的情况下允许家长进入教室旁听，与孩子一同成长', subTitle2: '线下辅导', text2: '线下辅导，与老师面对面交流，拉近与 老师的距离。', icon: dg_icon_2 },
            { title: '练', subTitle1: '错题本', text1: '记录孩子错题，随时查阅，巩固知识点记录自己的题目', subTitle2: '天天练', text2: '每天一题，巩固上课所学知识点，帮助 学生复习自己上课内容。', icon: dg_icon_3 }
        ]
    }
